import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getColor from "@insite/mobius/utilities/getColor";
import { totalStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsTotal";

totalStyles.orderTotal = mergeToNew(totalStyles.orderTotal, {
    container: {
        css: css`
        background: ${getColor("secondary")};
        padding: 15px;
    `,
    },
    totalLabel: {
        color: "text.accent",
    },
    totalValue: {
        color: "text.accent",
    },
});
